import { render } from "./AskusQuestion.vue?vue&type=template&id=15e22390&scoped=true&ts=true"
import script from "./AskusQuestion.vue?vue&type=script&lang=ts"
export * from "./AskusQuestion.vue?vue&type=script&lang=ts"

import "./AskusQuestion.vue?vue&type=style&index=0&id=15e22390&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/wdw-vue build and deploy Teledata PROD/wdw-vue-widgets/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15e22390"]])

export default __exports__